(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/load-draws-with-numbers.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/load-draws-with-numbers.js');
"use strict";


const {
  unwrapResult
} = RTK;
const logger = svs.core.log.getLogger('tipsen:route-competition');

const {
  loadOpenedDrawsByEngine
} = svs.components.sport.drawsRedux.actions;

async function loadDrawsWithGivenNumbersAsync(_ref) {
  let {
    drawNumbers,
    productId: _productId,
    allCurrentDraws,
    currentEngine,
    dispatch
  } = _ref;
  const [productIdByEngine] = currentEngine.drawProductIds;
  const productId = _productId || productIdByEngine;
  if (!Array.isArray(drawNumbers) || drawNumbers.some(item => typeof item !== 'number')) {
    throw new Error(drawNumbers ? 'Expected drawNumbers to be number[]' : 'Missing drawNumber');
  }
  if (typeof productId !== 'number') {
    throw new Error(productId ? 'Expected productId to be number' : 'Missing productId');
  }
  const _getAlreadyLoadedDrawOrNull = number => Array.isArray(allCurrentDraws) ? allCurrentDraws.find(loadedDraw => (loadedDraw === null || loadedDraw === void 0 ? void 0 : loadedDraw.drawNumber) === number && (loadedDraw === null || loadedDraw === void 0 ? void 0 : loadedDraw.productId) === productId) : null;
  if (drawNumbers.length === 0 || drawNumbers.every(_getAlreadyLoadedDrawOrNull)) {
    return drawNumbers.map(_getAlreadyLoadedDrawOrNull);
  }
  try {
    const results = await dispatch(loadOpenedDrawsByEngine(currentEngine));
    const fetchedDraws = unwrapResult(results).Draws;
    return drawNumbers.map(number => fetchedDraws.entities["".concat(productId, "_").concat(number)] || null);
  } catch (error) {
    if (error.name === 'ConditionError') {
      return drawNumbers.map(_getAlreadyLoadedDrawOrNull);
    }
    logger.warn('loadOpenedDrawsByEngine() failed -', error.message);
    throw error;
  }
}

setGlobal('svs.components.tipsen.routeCompetition', {
  loadDrawsWithGivenNumbersAsync
});

 })(window);